import { computed, defineComponent, ref } from "vue";
import { upload } from "@/service/canvas";
import { useStore } from "vuex";
export default defineComponent({
  name: "AiUploadImg",
  setup() {
    const store = useStore();
    const inputFile = ref(null);
    const uploadLoading = ref(false);
    const uploadFile = () => {
      inputFile.value.click();
    };
    const uploadImgs = computed(() => {
      return store.state.drawUploadImgs;
    });
    const changeFile = e => {
      let file = e.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = e => {
        // 图片base64化
        const base64Str = e.target.result; // 转化后的base64字符串
        inputFile.value.value = "";
        store.commit("SET_AI_UPLOADS", [...uploadImgs.value, base64Str]);
      };
    };
    return {
      inputFile,
      uploadLoading,
      uploadFile,
      changeFile,
      uploadImgs,
      removeImg(del) {
        const aflterImgs = uploadImgs.value.filter(item => item !== del);
        store.commit("SET_AI_UPLOADS", aflterImgs);
      }
    };
  }
});